export const surveyRoutes = {
  'route.survey.index': '/survey/[id]',

  'api.survey.store': 'survey',
};
